import React from "react";

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    // Check if data is not null or empty
    if (!payload || payload.length === 0) {
      return null;
    }

    // Calculate the total sum of data values
    const total = payload.reduce((sum, entry) => sum + entry.value, 0);

    // Calculate dynamic width based on data count and content length
    const dataCount = payload.length;
    const maxNameLength = Math.max(
      ...payload.map((entry) => entry.name?.length || 0)
    );
    const maxValueLength = Math.max(
      ...payload.map((entry) => entry.value?.toString().length || 0)
    );
    const labelLength = label?.toString().length || 0;

    // Base width calculation - adjusted for up to 3-column layout
    let dynamicWidth = Math.max(
      200, // Minimum width
      dataCount > 15
        ? Math.min(600, (maxNameLength + maxValueLength) * 20 + 180) // 3-column width
        : dataCount > 6
        ? Math.min(500, (maxNameLength + maxValueLength) * 16 + 120) // 2-column width
        : (maxNameLength + maxValueLength) * 8 + 60, // Single column width
      labelLength * 8 + 100 // Label width consideration
    );

    return (
      <div
        className="bg-white rounded-md border border-gray-600 shadow-lg"
        style={{
          width: `${dynamicWidth}px`,
          maxWidth: "650px", // Increased max width for 3 columns
          minWidth: "200px", // Ensure minimum readability
        }}
      >
        <div className="p-3 max-h-[400px] overflow-auto">
          <p className="font-semibold mb-2 text-sm">
            Stay Duration: {`${label}`}
          </p>
          {/* Dynamic column layout based on data count */}
          <div
            className={`grid gap-x-3 gap-y-1 ${
              dataCount > 15
                ? "grid-cols-3"
                : dataCount > 6
                ? "grid-cols-2"
                : "grid-cols-1"
            }`}
          >
            {payload.map((entry, index) => (
              <div
                key={index}
                className="flex justify-between items-center text-sm min-w-0"
              >
                <span
                  style={{ color: entry.color }}
                  className="truncate pr-1 flex-shrink text-xs"
                >
                  {entry.name}:
                </span>
                <span className="font-medium flex-shrink-0 text-xs">
                  {entry.value}
                </span>
              </div>
            ))}
          </div>
          {/* Uncomment if you want to show total */}
          {/* <div className="mt-2 pt-2 border-t border-gray-200">
            <p className="font-semibold text-sm">Total Packages: {total}</p>
          </div> */}
        </div>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
